import React from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import parse from 'html-react-parser';
import { TypeAnimation } from 'react-type-animation';

import BgVideo from '../../../assets/video/nations.mp4';
import StyledWhoIsJadeSoft from './styles';

import { useTranslation } from 'react-i18next';
import AllFlag from '../../../assets/images/home/AllFlag.png';
import Flags from '../../../assets/images/home/Flags.png';

// import { S3 } from '../../../config/api';

// const bannerText =
// 'Reinventing the platform and developing one from scratch — the Jade Soft team is ready to take on your challenges and create an outstanding tailored iGaming solution';

const WhoIsJadeSoft = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const label2 = t('whois-label-two');
    const label2Mobile = t('whois-label-two');

    return (
        <StyledWhoIsJadeSoft>
            {/* <Box
        sx={{
          height: '20px',
          [theme.breakpoints.down('lg')]: {
            display: 'none !important',
          },
        }}
      ></Box> */}
            <Box className="homeBg">
                <video width="100%" autoPlay loop muted playsInline className="videoElement">
                    <source src={BgVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </Box>
            <Box className="homeContent">
                {/* <Box className="iconBrandLogo" sx={{ height: '170px' }}>
            <IconBrandLogo />
          </Box> */}
                <Box sx={{ textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
                    <Grid
                        container
                        sx={{
                            marginLeft: '250px',
                        }}
                    >
                        <Grid item>
                            <Typography
                                variant="h2"
                                component="h2"
                                sx={{
                                    fontSize: '48px',
                                    fontWeight: '800',
                                    lineHeight: '57.28px',
                                    mb: 8,
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '40px',
                                        lineHeight: '47.73px',
                                        display: 'none',
                                    },
                                }}
                            >
                                {t('whois-label-one') + parse('&nbsp')}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h2"
                                component="h2"
                                sx={{
                                    fontSize: '48px',
                                    fontWeight: '800',
                                    lineHeight: '57.28px',
                                    mb: 8,
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '40px',
                                        lineHeight: '47.73px',
                                        display: 'none',
                                    },
                                }}
                            >
                                <TypeAnimation
                                    preRenderFirstString={true}
                                    sequence={[
                                        // Same substring at the start will only be typed once, initially
                                        'KOREA',
                                        1000,
                                        'THAILAND',
                                        1000,
                                        'INDONESIA',
                                        1000,
                                        'JAPAN',
                                        1000,
                                        'MALAYSIA',
                                        1000,
                                        'BRAZIL',
                                        1000,
                                        'VIETNAM',
                                        1000,
                                        'CHINA',
                                        1000,
                                        'ARGENTINA',
                                        1000,
                                    ]}
                                    speed={50}
                                    // deletionSpeed={50}
                                    // style={{ fontSize: '2em' }}
                                    // speed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                    // deletionSpeed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                    repeat={Infinity}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            fontSize: '48px',
                            fontWeight: '800',
                            lineHeight: '57.28px',
                            mt: 8,
                            display: 'none',
                            [theme.breakpoints.down('lg')]: {
                                fontSize: '50px',
                                lineHeight: '59.67px',
                                display: 'flex',
                                textAlign: 'center',
                                justifyContent: 'center',
                            },
                        }}
                    >
                        {parse(t('whois-label-one'))}
                    </Typography>
                    <Grid sx={{
                        [theme.breakpoints.down('lg')]: {
                            height: "80px"
                        }
                    }}>
                        <Typography
                            variant="h2"
                            component="h2"
                            sx={{
                                fontSize: '48px',
                                fontWeight: '800',
                                mb: 5,
                                display: 'none',
                                [theme.breakpoints.down('lg')]: {
                                    fontSize: '40px',
                                    lineHeight: '47.73px',
                                    display: 'flex',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                },
                            }}
                        >
                            <TypeAnimation
                                preRenderFirstString={true}
                                sequence={[
                                    // Same substring at the start will only be typed once, initially
                                    'KOREA',
                                    1000,
                                    'THAILAND',
                                    1000,
                                    'INDONESIA',
                                    1000,
                                    'JAPAN',
                                    1000,
                                    'MALAYSIA',
                                    1000,
                                    'BRAZIL',
                                    1000,
                                    'VIETNAM',
                                    1000,
                                    'CHINA',
                                    1000,
                                    'ARGENTINA',
                                    1000,
                                ]}
                                speed={50}
                                // deletionSpeed={50}
                                // style={{ fontSize: '2em' }}
                                // speed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                // deletionSpeed={{ type: 'keyStrokeDelayInMs', value: 250 }}
                                repeat={Infinity}
                                cursor={false}
                            />
                        </Typography>
                    </Grid>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            mb: 10,
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                wordWrap: 'break-word',
                                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '600' : '700',
                                fontSize: '20px',
                                lineHeight: '23.87px',
                                [theme.breakpoints.down('lg')]: {
                                    fontSize: '18px',
                                    lineHeight: '21.48px',
                                    display: 'none',
                                },
                            }}
                        >
                            {parse(label2)}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                lineHeight: 1.8,
                                wordWrap: 'break-word',
                                fontWeight: 700,
                                fontSize: '20px',
                                lineHeight: '26px',
                                display: 'none',
                                [theme.breakpoints.down('lg')]: {
                                    fontWeight: 500,
                                    fontSize: '18px',
                                    lineHeight: '23.4px',
                                    display: 'flex',
                                },
                            }}
                            className='label2'
                        >
                            {parse(label2Mobile)}
                        </Typography>
                    </Box>
                    <Box
                        mb={40}
                        sx={{
                            display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' },
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <img
                            src={AllFlag}
                            style={{
                                width: '961.03px',
                                height: '220px',
                                maxWidth: '100%',
                                height: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </Box>
                    <Box
                        // mb={40}
                        sx={{
                            display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' },
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            mb: 5,
                        }}
                    >
                        <img
                            src={Flags}
                            style={{
                                width: '248px',
                                height: '283px',
                                maxWidth: '100%',
                                height: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </Box>
                </Box>

                {/* <Container maxWidth="lg">
          <motion.div
            className="card"
            initial={{
              opacity: 0,
              y: 290,
            }}
            whileInView={{
              opacity: 1,
              y: 0, // Slide in to its original position
              transition: {
                duration: 2, // Animation duration
              },
            }}
            // viewport={{ once: true }}
          >
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
              <Box className="bannerText" mt={2} mx={8}>
                {bannerText}
              </Box>
              <Box mt={5}>
                <Button hasEndIcon IconEnd={ArrowForwardIosIcon} text="Get Started" color={COLOR.DEFAULT} />
              </Box>
            </Box>
          </motion.div>
        </Container> */}
            </Box>
        </StyledWhoIsJadeSoft>
    );
};

export default WhoIsJadeSoft;
